var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-tree-container" }, [
    _c("div", { staticClass: "file-tree-content" }, [
      _vm.loading
        ? _c("div", { staticClass: "tree-loading" }, [_vm._m(0)])
        : _vm.error
        ? _c("div", { staticClass: "tree-error" }, [
            _vm._v(" " + _vm._s(_vm.error) + " ")
          ])
        : _c("div", { staticClass: "tree-view-content" }, [
            _c(
              "ul",
              { staticClass: "tree-root" },
              _vm._l(_vm.treeItemsToRender, function(item, index) {
                return _c(
                  "li",
                  { key: "tree-root-" + index, staticClass: "tree-item" },
                  [
                    _c("tree-node", {
                      attrs: {
                        item: item,
                        level: 0,
                        "is-shared-context": _vm.isSharedContext,
                        "current-path": _vm.currentPath,
                        "file-explorer-service": _vm.fileExplorerService,
                        "drive-public-service": _vm.drivePublicService
                      },
                      on: { "node-click": _vm.handleNodeClick }
                    })
                  ],
                  1
                )
              }),
              0
            ),
            _vm.isTreeItemsEmpty
              ? _c("div", { staticClass: "tree-empty" }, [
                  _c("span", [_vm._v(_vm._s(_vm.emptyMessage))])
                ])
              : _vm._e()
          ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Carregando...")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }